import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deleteData, getData, getDataById, postData, postDataWithParams, updateData } from "../../../service/Service";

const initialState = {
  data: {
    docs: [],
  },
  updatedTime:0,
  isLoading: true,
  isError: "",
  message: "",
  postMessage: "",
  postStatus: "",
  deleteMessage: "",
  deleteStatus: "",
  updateMessage: "",
  updateStatus: "",
};

export const getFarmer = createAsyncThunk(
  "admin/farmer",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getData("/master/farmer", data.token, data.params);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const getFarmerById = createAsyncThunk(
  "admin/farmer/id",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getDataById("/master/farmer/", data.token, data.id);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const sortFarmer = createAsyncThunk(
  "admin/farmer/sort",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postDataWithParams(
        "/master/farmer/search",
        data.token,
        data.body,
        data.params
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const postFarmer = createAsyncThunk(
  "admin/farmer/post",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postData("/master/farmer", data.token, data.data);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteFarmer = createAsyncThunk(
  "admin/farmer/delete",
  async (data, { rejectWithValue }) => {
    try {
      const result = await deleteData("/master/farmer/", data.token, data.data);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const updateFarmer = createAsyncThunk(
  "admin/farmer/edit",
  async (data, { rejectWithValue }) => {
    try {
      const result = await updateData(
        "/master/farmer",
        data.token,
        data.id,
        data.value
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const farmerSlice = createSlice({
  name: "Farmer Store",
  initialState: initialState,
  reducers: {
    addFarmer(state, action) {
      state.data.docs.unshift(action.payload);
    },
    sortFarmer(state, action) {
      state.data.docs = action.payload;
    },
    deleteFarmer(state, action) {
      state.data.docs = state.data.docs.filter(
        (item) => item._id !== action.payload
      );
    },
    editFarmer(state, action) {
      let x = state.data.docs.findIndex((item) => item._id === action.payload._id);
      state.data.docs[x] = action.payload;
    },
  },
  extraReducers: {
    [getFarmer.pending]: (state, ) => {
      state.isLoading = true;
    },
    [getFarmer.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.updatedTime = Date.now();
      state.message = action.payload.message;
    },
    [getFarmer.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getFarmerById.pending]: (state, ) => {
      state.isLoading = true;
    },
    [getFarmerById.fulfilled]: (state, action) => {
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getFarmerById.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortFarmer.pending]: (state, ) => {
      state.isLoading = true;
    },
    [sortFarmer.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortFarmer.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [postFarmer.pending]: (state, ) => {
      state.isLoading = true;
    },
    [postFarmer.fulfilled]: (state, action) => {
      state.postMessage = action.payload.message;
      state.postStatus = action.payload.status;
    },
    [postFarmer.rejected]: (state, action) => {
      state.isError = true;
      state.postMessage = action.payload.message;
    },
    [deleteFarmer.pending]: (state, ) => {
      state.isLoading = true;
    },
    [deleteFarmer.fulfilled]: (state, action) => {
      state.deleteMessage = action.payload.message;
      state.deleteStatus = action.payload.status;
    },
    [deleteFarmer.rejected]: (state, action) => {
      state.isError = true;
      state.deleteMessage = action.payload.message;
    },
    [updateFarmer.pending]: (state, ) => {
      state.isLoading = true;
    },
    [updateFarmer.fulfilled]: (state, action) => {
      state.updateMessage = action.payload.message;
      state.status = action.payload.status;
    },
    [updateFarmer.rejected]: (state, action) => {
      state.isError = true;
      state.updateMessage = action.payload.message;
    },
  },
});

export const farmerActions = farmerSlice.actions;

export default farmerSlice.reducer;
